import {isAuthenticated} from 'src/shared/auth/selectors';
import {account} from 'src/shared/config/urls';
import {createLoggerMiddleware} from 'src/shared/logger/middleware';
import {
  accountNumber,
  user,
  userRole,
} from 'src/shared/user/selectors';
import {accountNumber as linkedAccountNumber} from 'src/shared/linkedAccounts/selectors';

export const loggerMiddleware = createLoggerMiddleware({
  component: 'XHS-PAGE-SCHEDULE-CALLBACK',
  page: 'schedule-callback',
  typesWithCustomValues: {
    READ_ACCOUNT_ERROR: (value, state) => ({
      accountNumber: accountNumber(state),
      accountStatus: user(state).accountStatus,
      accountType: user(state).accountType,
      accountUrl: account(state),
      authGuid: user(state).authGuid,
      customerGuid: user(state).customerGuid,
      errorMessage: value?.error?.message || '',
      isAuthenticated: isAuthenticated(state),
      linkedAccountNumber: linkedAccountNumber(state),
      role: userRole(state),
      x1Account: user(state).x1Account,
    }),
  },
});
